import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Use the raw response from the http repository to create a Vehicle History Value Object.
 */
export class FromAdDetailsRawDataToVehicleHistoryValueObjectMapper extends Mapper {
  constructor({config, fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper}) {
    super()

    this._config = config
    this._fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper =
      fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper
    this._carfaxSellerTypes = this._config.get('CARFAX_SELLER_TYPES')
  }

  map = async rawData => {
    const {ad} = rawData

    const {vehicleHistory = {}} = rawData

    const sellerType = ad.professionalSeller ? this._carfaxSellerTypes.PROFESSIONAL : this._carfaxSellerTypes.PRIVATE

    return this._fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper
      .setParams({
        hasReport: vehicleHistory.hasReport,
        reportUrl: vehicleHistory.reportUrl,
        sellerType,
        vehicleData: vehicleHistory.vehicleData
      })
      .map()
  }
}
